export type Permission = 'Admin' | 'Backoffice';

export interface MenuItemPermission {
  text: string;
  path: string;
  requiredPermission: Permission | null; // null means accessible to all authenticated users
}

export const MENU_ITEMS_PERMISSIONS: MenuItemPermission[] = [
  { text: 'Dashboard', path: '/dashboard', requiredPermission: null },
  { text: 'Users', path: '/users', requiredPermission: 'Backoffice' },
  { text: 'Organizations', path: '/organizations', requiredPermission: 'Admin' },
  { text: 'Permissions', path: '/permissions', requiredPermission: 'Admin' },
  { text: 'Permission Groups', path: '/permission-groups', requiredPermission: 'Admin' },
  { text: 'Project Analytics', path: '/project-analytics', requiredPermission: 'Backoffice' },
  { text: 'Properties', path: '/properties', requiredPermission: 'Admin' },
  { text: 'Analytics', path: '/analytics', requiredPermission: 'Admin' },
];

export const hasPermission = (
  userPermissions: string[] | undefined,
  requiredPermission: Permission | null
): boolean => {
  // If no permission required, allow access
  if (requiredPermission === null) {
    return true;
  }

  // If no user permissions, deny access
  if (!userPermissions || userPermissions.length === 0) {
    return false;
  }

  // Check if user has the required permission
  return userPermissions.includes(requiredPermission);
};

export const filterMenuItemsByPermissions = (
  menuItems: MenuItemPermission[],
  userPermissions: string[] | undefined
): MenuItemPermission[] => {
  return menuItems.filter(item => 
    hasPermission(userPermissions, item.requiredPermission)
  );
};
